<div class="ext--wrap">
  <div class="ext--head">
    <img src="assets/logo-primary.png" alt="Vodori"/>
  </div>
  <div class="ext--body">
    <div class="ext--text">
      @if (loading()) {
        <app-loading></app-loading>
      } @else {
        @if (authenticated()) {
          @if (!hasCloudProductPersona) {
            <p>You do not have the necessary permissions to use Vodori Web Annotation. Contact your organization administrator.</p>
          } @else {
            <!-- Will redirect to Cloud's extension component -->
          }
        } @else {
          <p>
            To access Vodori Web Annotation, open a new window and sign in to Vodori.
            Then return to this tab and the browser will reload your web page.
          </p>
          <a href="/login" target="_blank" class="button">Sign in</a>
        }
      }
    </div>
  </div>
  <div class="ext--footer">
    <a (click)="returnToTenantSelector()" class="button secondary">
      Return to organization selector
    </a>
  </div>
</div>
